class Mencao {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.nome = dados ? dados.nome : null;
    this.simbolo = dados ? dados.simbolo : null;
  }
}
export default Mencao;
